import { render, staticRenderFns } from "./JoinFreshClinics.vue?vue&type=template&id=7d20f4be&"
import script from "./JoinFreshClinics.vue?vue&type=script&lang=js&"
export * from "./JoinFreshClinics.vue?vue&type=script&lang=js&"
import style0 from "./JoinFreshClinics.vue?vue&type=style&index=0&id=7d20f4be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports